import {followCopy} from './follow-copy.js';
/** Authored interface strings only; never applied to user content. */
export const additionalCopy = {
  '消息': ['Messages', 'メッセージ'],
  '收藏与加入': ['Saves & joins', '保存と参加'],
  '新增关注': ['New followers', '新しいフォロワー'],
  '评论和回复': ['Comments & replies', 'コメントと返信'],
  '系统通知': ['System', 'システム通知'],
  '协作消息': ['Collaborations', '共同制作'],
  '权益与礼物': ['Benefits & gifts', '特典とギフト'],
  '互动消息': ['Activity', 'アクティビティ'],
  '通知设置': ['Notification settings', '通知設定'],
  '消息选项': ['Message options', 'メッセージのオプション'],
  '消息详情': ['Message', 'メッセージ詳細'],
  '返回消息': ['Back to messages', 'メッセージに戻る'],
  '部分消息暂未同步': ['Some messages could not be synced', '一部のメッセージを同期できませんでした'],
  '{count} 条未读': ['{count} unread', '未読 {count} 件'],
  "愿你在此寻得所爱，让喜欢的作品，成为身边的风景。": ["May you find something to love here, and bring a favorite work into your everyday surroundings.", "ここで好きな作品に出会い、日常の風景に迎えられますように。"],
  "入门指南": ["Getting started", "入門ガイド"],
  "平台介绍与使用说明。": ["About the platform and how to use it.", "プラットフォームの紹介と使い方。"],
  "来访指引": ["Visitor guidance", "ご利用ガイド"],
  "社区与内容展示规范": ["Community and Content Display Guidelines", "コミュニティとコンテンツ表示ガイドライン"],

  "在这里发现喜欢的作品与周边，收藏心仪的创作；也可以上传作品、整理自己的系列，在许可范围内设计和发行周边。": ["Discover works and merch you love and save your favorites. You can also upload works, organize your series, and design and release merch within the relevant licenses.", "好きな作品やグッズを見つけ、気に入った創作を保存しましょう。作品のアップロード、シリーズの整理、許諾の範囲でのグッズのデザインとリリースもできます。"],
  "工房操作": ["Workshop actions", "工房の操作"],
  '留言板设置': ['Guestbook settings', 'ゲストブックの設定'],
  ...followCopy,
  "机构账号；尚未取得有效身份认证": [
    "Organization account; identity not yet verified",
    "組織アカウント（本人確認未完了）"
  ],
  "机构": [
    "Organization",
    "組織"
  ],
  "身份认证详情": [
    "Identity verification details",
    "本人確認の詳細"
  ],
  "认证主体": [
    "Verified entity",
    "確認済みの主体"
  ],
  "认证说明": [
    "Verification details",
    "確認について"
  ],
  "该账号与所示主体的关系及运营授权已经平台审核。": [
    "The platform has verified this account's relationship with the named entity and its authority to act for it.",
    "このアカウントと表示された主体との関係、および運営権限はプラットフォームが確認済みです。"
  ],
  "此标识说明身份与代表关系；具体作品的权利及使用范围请查看相应项目。": [
    "This badge confirms identity and representation. See each project for rights and permitted uses of its works.",
    "このマークは本人確認と代表権を示します。作品の権利や利用範囲は各プロジェクトで確認してください。"
  ],
  "知道了": [
    "Got it",
    "わかりました"
  ],
  "机构与身份": [
    "Organization and identity",
    "組織と本人確認"
  ],
  "公开 User ID": [
    "Public user ID",
    "公開ユーザーID"
  ],
  "关闭": [
    "Close",
    "閉じる"
  ],
  "关闭结构引导": [
    "Close the introduction",
    "紹介を閉じる"
  ],
  "认识交汇地": [
    "Explore the Crossroads",
    "交差点を知る"
  ],
  "正在准备…": [
    "Preparing…",
    "準備中…"
  ],
  "下一步": [
    "Next",
    "次へ"
  ],
  "选择业务用途…": [
    "Choose a use…",
    "用途を選択…"
  ],
  "搜索用途或类别": [
    "Search uses or categories",
    "用途やカテゴリを検索"
  ],
  "搜索业务用途": [
    "Search business purposes",
    "用途を検索"
  ],
  "关闭用途选择": [
    "Close use selector",
    "用途の選択を閉じる"
  ],
  "业务用途": [
    "Business purpose",
    "用途"
  ],
  "没有匹配的用途，试试其他关键词。": [
    "No matching uses. Try another keyword.",
    "一致する用途がありません。別のキーワードをお試しください。"
  ],
  "重试": [
    "Retry",
    "再試行"
  ],
  "未命名资产": [
    "Untitled asset",
    "無題のアセット"
  ],
  "接受后归入 ": [
    "Accept and move to ",
    "承認して次へ分類："
  ],
  "对应业务文件夹": [
    "its designated folder",
    "対応するフォルダ"
  ],
  "补充名称": [
    "Add a name",
    "名前を追加"
  ],
  "保持空白": [
    "Leave blank",
    "空欄のままにする"
  ],
  "补充描述": [
    "Add a description",
    "説明を追加"
  ],
  "也可以手动选择用途": [
    "You can also choose a use manually",
    "用途を手動で選択することもできます"
  ],
  "不采用": [
    "Dismiss",
    "採用しない"
  ],
  "接受": [
    "Accept",
    "採用"
  ],
  "恢复建议": [
    "Restore suggestion",
    "提案を復元"
  ],
  "整理": [
    "Organize",
    "整理"
  ],
  "整理结果": [
    "Organization results",
    "整理結果"
  ],
  "正在整理": [
    "Organizing",
    "整理中"
  ],
  "业务在后台继续，你可以先做其他事。": [
    "Work continues in the background. You can do something else.",
    "処理はバックグラウンドで続きます。他の作業を進められます。"
  ],
  "接受建议后归类；已有名称与描述会保留。": [
    "Accept suggestions to categorize items. Existing names and descriptions are preserved.",
    "提案を承認すると分類されます。既存の名前と説明は保持されます。"
  ],
  "稍后处理": [
    "Do this later",
    "後で処理"
  ],
  "整理记录": [
    "Organization history",
    "整理履歴"
  ],
  "正在读取选定范围…": [
    "Loading the selected scope…",
    "選択した範囲を読み込み中…"
  ],
  "这个范围没有新的待整理内容。已有分类和未采用的建议会保留。": [
    "There is nothing new to organize here. Existing categories and dismissed suggestions are preserved.",
    "この範囲に新しく整理する内容はありません。既存の分類と不採用の提案は保持されます。"
  ],
  "整理新内容": [
    "Organize new items",
    "新しい内容を整理"
  ],
  "全部不采用": [
    "Dismiss all",
    "すべて不採用"
  ],
  "确认操作": [
    "Confirm action",
    "操作を確認"
  ],
  "取消": [
    "Cancel",
    "キャンセル"
  ],
  "确认": [
    "Confirm",
    "確認"
  ],
  "从这里开始创作。": [
    "Start creating here.",
    "ここから創作を始めましょう。"
  ],
  "点击「创建系列」。": [
    "Select “Create a series”.",
    "「シリーズを作成」を選択します。"
  ],
  "给系列起个名字。": [
    "Give your series a name.",
    "シリーズに名前を付けましょう。"
  ],
  "进入刚刚创建的系列。": [
    "Open the series you just created.",
    "作成したシリーズを開きます。"
  ],
  "点击右上角的 ＋。": [
    "Select ＋ in the top right.",
    "右上の ＋ を選択します。"
  ],
  "系列用来收存你的设定、故事与素材。": [
    "A series holds your lore, stories and materials.",
    "シリーズには設定、物語、素材を保存できます。"
  ],
  "填写后，点击「创建系列」。": [
    "Then select “Create a series”.",
    "入力後、「シリーズを作成」を選択します。"
  ],
  "接下来，在档案里放入素材。": [
    "Next, add materials to the Archive.",
    "次に、アーカイブに素材を追加します。"
  ],
  "选择系列": [
    "Choose a Series",
    "シリーズを選択"
  ],
  "全部公开系列": [
    "All public series",
    "公開シリーズ一覧"
  ],
  "查找创作": [
    "Find a creation",
    "創作を検索"
  ],
  "已选创作": [
    "Selected creation",
    "選択した創作"
  ],
  "未公开或已移除的创作": [
    "Private or removed creation",
    "非公開または削除された創作"
  ],
  "正在寻找可展示的创作…": [
    "Finding available creations…",
    "表示できる創作を検索中…"
  ],
  "没有找到匹配的创作。": [
    "No matching creations.",
    "一致する創作がありません。"
  ],
  "暂无公开创作。": [
    "No public creations yet.",
    "公開された創作はまだありません。"
  ],
  "正在保存…": [
    "Saving…",
    "保存中…"
  ],
  "保存选择": [
    "Save selection",
    "選択を保存"
  ],
  "回复留言": [
    "Reply to message",
    "メッセージに返信"
  ],
  "写留言": [
    "Leave a message",
    "メッセージを書く"
  ],
  "回复内容": [
    "Reply",
    "返信内容"
  ],
  "留言内容": [
    "Message",
    "メッセージ内容"
  ],
  "回复这位来访者…": [
    "Reply to this visitor…",
    "訪問者に返信…"
  ],
  "来营地坐坐，留句话吧。": [
    "Stop by the camp and leave a message.",
    "キャンプに立ち寄って、ひとこと残しましょう。"
  ],
  "附上一件创作": [
    "Attach a creation",
    "創作を添付"
  ],
  "登录后，来留句话": [
    "Sign in to leave a message",
    "ログインしてメッセージを書く"
  ],
  "正在读取留言板…": [
    "Loading the message board…",
    "メッセージボードを読み込み中…"
  ],
  "留言板": [
    "Message board",
    "メッセージボード"
  ],
  "开放留言": [
    "Allow messages",
    "メッセージを受け付ける"
  ],
  "已关闭": [
    "Closed",
    "終了"
  ],
  "暂未开放": [
    "Not open yet",
    "まだ公開されていません"
  ],
  "留言内容列表": [
    "Messages",
    "メッセージ一覧"
  ],
  "还没有留言": [
    "No messages yet",
    "メッセージはまだありません"
  ],
  "留言板暂未开放": [
    "The message board is not open yet",
    "メッセージボードはまだ公開されていません"
  ],
  "置顶": [
    "Pin",
    "固定"
  ],
  "主人回复": [
    "Owner's reply",
    "オーナーの返信"
  ],
  "前往 ": [
    "Go to ",
    "移動先："
  ],
  "删除留言": [
    "Delete message",
    "メッセージを削除"
  ],
  "删除这条留言？": [
    "Delete this message?",
    "このメッセージを削除しますか？"
  ],
  "留言及主人的回复会一起删除。": [
    "The message and the owner's reply will both be deleted.",
    "メッセージとオーナーの返信が削除されます。"
  ],
  "侍灵暂时未能连接。": [
    "The Attendant could not connect.",
    "アシスタントに接続できませんでした。"
  ],
  "正在连接侍灵…": [
    "Connecting Attendant...",
    "アシスタント を接続中..."
  ],
  "侍灵对话": [
    "Attendant conversation",
    "アシスタントとの会話"
  ],
  "正在进入个人事务…": [
    "Opening settings…",
    "設定を開いています…"
  ],
  "正在完成登录…": [
    "Completing sign-in…",
    "ログインを完了しています…"
  ],
  "已归档": [
    "Archived",
    "アーカイブ済み"
  ],
  "来源读取失败，重试": [
    "Could not load the source. Try again.",
    "出典を読み込めませんでした。再試行してください。"
  ],
  "收回侍灵": [
    "Minimize Agent",
    "アシスタントを隠す"
  ],
  "打开侍灵": [
    "Open Agent",
    "アシスタントを開く"
  ],
  "收回侍灵；按 / 聚焦输入框": [
    "Hide the Attendant; press / to focus the input",
    "アシスタントを閉じる（/ キーで入力欄へ）"
  ],
  "打开侍灵（/）": [
    "Open the Attendant (/)",
    "アシスタントを開く（/）"
  ],
  "搜索或问侍灵…": [
    "Search or ask the Attendant…",
    "検索、またはアシスタントに質問…"
  ],
  "侍灵正在准备": [
    "The Attendant is getting ready",
    "アシスタントを準備中"
  ],
  "切换为浅色": [
    "Switch to light mode",
    "ライトモードに切り替え"
  ],
  "切换为深色": [
    "Switch to dark mode",
    "ダークモードに切り替え"
  ],
  "登录": [
    "Log in",
    "ログイン"
  ],
  "账号退出暂未完成。": [
    "Sign-out has not completed.",
    "ログアウトが完了していません。"
  ],
  "重试退出": [
    "Try signing out again",
    "ログアウトを再試行"
  ],
  "档案工作区": [
    "Archive workspace",
    "アーカイブの作業スペース"
  ],
  "市集工作区": [
    "Market workspace",
    "マーケットの作業スペース"
  ],
  "工房工作区": [
    "Workshop workspace",
    "工房の作業スペース"
  ],
  "工作区暂时未能打开": [
    "The workspace could not be opened",
    "作業スペースを開けませんでした"
  ],
  "在新标签页打开": [
    "Open in a new tab",
    "新しいタブで開く"
  ],
  "营地": [
    "Camp",
    "キャンプ"
  ],
  "收藏的系列": [
    "Saved series",
    "保存したシリーズ"
  ],
  "系列": [
    "Series",
    "シリーズ"
  ],
  "创建系列": [
    "Create a series",
    "シリーズを作成"
  ],
  "正在加载营地": [
    "Loading Camp…",
    "キャンプを読み込み中…"
  ],
  "查找收藏的系列": [
    "Search saved series",
    "保存したシリーズを検索"
  ],
  "发现系列 →": [
    "Discover series →",
    "シリーズを探す →"
  ],
  "正在加载系列": [
    "Loading Series",
    "シリーズを読み込み中"
  ],
  "置顶系列": [
    "Series",
    "シリーズ"
  ],
  "最近系列": [
    "Recent series",
    "最近のシリーズ"
  ],
  "营地系列": [
    "Camp series",
    "キャンプのシリーズ"
  ],
  "完成管理": [
    "Done managing",
    "管理を終了"
  ],
  "管理": [
    "Management",
    "経営"
  ],
  "刷新系列": [
    "Refresh series",
    "シリーズを更新"
  ],
  "降序排列，切换为升序": [
    "Sorted descending; switch to ascending",
    "降順。昇順に切り替える"
  ],
  "升序排列，切换为降序": [
    "Sorted ascending; switch to descending",
    "昇順。降順に切り替える"
  ],
  "降序": [
    "Descending",
    "降順"
  ],
  "升序": [
    "Ascending",
    "昇順"
  ],
  "系列名称": [
    "Project name",
    "シリーズの名前"
  ],
  "未命名系列": [
    "Untitled series",
    "無題のシリーズ"
  ],
  "正在创建…": [
    "Creating…",
    "作成中…"
  ],
  "重试创建": [
    "Retry creation",
    "作成を再試行"
  ],
  "创建": [
    "Created",
    "作成"
  ],
  "列表暂时无法加载": [
    "Could not load the list",
    "一覧を読み込めませんでした"
  ],
  "正在加载": [
    "Loading",
    "ローディング"
  ],
  "还没有粉丝": [
    "No followers yet",
    "フォロワーはまだいません"
  ],
  "还没有关注任何人": [
    "Not following anyone yet",
    "フォロー中のユーザーはいません"
  ],
  "显示最近 50 位": [
    "Showing the latest 50 people",
    "最新の50人を表示"
  ],
  "编辑个人资料": [
    "Edit profile",
    "プロフィールを編集"
  ],
  "关注统计": [
    "Follow statistics",
    "フォロー情報"
  ],
  "档案": [
    "Archive",
    "アーカイブ"
  ],
  "我的工作区": [
    "My workspace",
    "マイワークスペース"
  ],
  "查看档案": [
    "View profile",
    "プロフィールを見る"
  ],
  "个人资料": [
    "Profile",
    "プロフィール"
  ],
  "自定义置顶": [
    "Customize pinned items",
    "ピン留めを編集"
  ],
  "自定义置顶系列": [
    "Choose pinned series",
    "ピン留めするシリーズを選択"
  ],
  "选择最多 4 个系列，显示在营地。": [
    "Choose up to 4 series to show in your camp.",
    "キャンプに表示するシリーズを最大4つ選べます。"
  ],
  "查找系列": [
    "Search Series",
    "シリーズを検索"
  ],
  "查找可置顶系列": [
    "Find series to pin",
    "ピン留めするシリーズを検索"
  ],
  "当前仅在档案可用": [
    "Currently available in the Archive only",
    "現在はアーカイブでのみ利用できます"
  ],
  "正在保存": [
    "Saving",
    "節約"
  ],
  "保存置顶": [
    "Save pinned items",
    "ピン留めを保存"
  ],
  "正在加载收藏": [
    "Loading saved items",
    "保存したアイテムを読み込み中"
  ],
  "没有匹配的收藏": [
    "No matching saved items",
    "一致するアイテムがありません"
  ],
  "把喜欢的系列留在这里": [
    "Keep your favorite series here",
    "お気に入りのシリーズをここに保存"
  ],
  "试试其他关键词。": [
    "Try another keyword.",
    "別のキーワードをお試しください。"
  ],
  "在交汇之地收藏系列后，就可以从档案和工房随时回来查看。": [
    "Save series at the Crossroads and return to them from the Archive or Workshop at any time.",
    "交差点でシリーズを保存すると、アーカイブや工房からいつでも戻れます。"
  ],
  "收藏系列列表": [
    "Saved series",
    "保存したシリーズ一覧"
  ],
  "正在更新": [
    "Updating",
    "更新中"
  ],
  "已收藏": [
    "Saved",
    "保存済み"
  ],
  "创作者产品": [
    "Creator products",
    "クリエイター向け製品"
  ],
  "全局导航": [
    "Global navigation",
    "共通ナビゲーション"
  ],
  "导航与公告栏": [
    "Navigation and bulletin",
    "ナビゲーションと掲示板"
  ],
  "交汇地、系列与公告栏": [
    "Crossroads, series and bulletin",
    "交差点、シリーズ、掲示板"
  ],
  "去往": [
    "Go to",
    "移動"
  ],
  "发布": [
    "Publish",
    "公開"
  ],
  "我的营地": [
    "My camp",
    "自分のキャンプ"
  ],
  "打开工作区": [
    "Open workspace",
    "作業スペースを開く"
  ],
  "正在恢复同一系列…": [
    "Reopening this series…",
    "このシリーズを開いています…"
  ],
  "返回": [
    "Back",
    "戻る"
  ],
  "信箱": [
    "Inbox",
    "受信箱"
  ],
  "打开完整信箱": [
    "Open full inbox",
    "受信箱全体を開く"
  ],
  "关闭信箱": [
    "Close inbox",
    "受信箱を閉じる"
  ],
  "登录后查看你的来信": [
    "Sign in to read your messages",
    "ログインしてメッセージを読む"
  ],
  "互动消息与个人提醒会收在这里。": [
    "Interactions and personal reminders appear here.",
    "交流に関する通知や個人向けのお知らせが届きます。"
  ],
  "查看全部消息": [
    "View all messages",
    "すべてのメッセージを見る"
  ],
  "消息列表": [
    "Message list",
    "メッセージ一覧"
  ],
  "未读": [
    "Unread",
    "未読"
  ],
  "返回消息列表": [
    "Back to messages",
    "メッセージ一覧に戻る"
  ],
  "新的互动与来信会出现在这里。": [
    "New interactions and messages appear here.",
    "新しい交流やメッセージがここに表示されます。"
  ],
  "返回上一页": [
    "Go back",
    "前のページに戻る"
  ],
  "最近消息": [
    "Recent messages",
    "最近のメッセージ"
  ],
  "正在标记…": [
    "Marking as read…",
    "既読にしています…"
  ],
  "全部已读": [
    "Mark all as read",
    "すべて既読にする"
  ],
  "正在同步消息…": [
    "Syncing messages…",
    "メッセージを同期中…"
  ],
  "暂无消息": [
    "No messages yet",
    "メッセージはありません"
  ],
  "加载中…": [
    "Loading…",
    "読み込み中…"
  ],
  "更早的消息": [
    "Older messages",
    "以前のメッセージ"
  ],
  "查阅完整公告": [
    "View the complete announcement",
    "発表全体を見る"
  ],
  "选择一条消息": [
    "Select a message",
    "メッセージを選択"
  ],
  "通知偏好": [
    "Notification preferences",
    "通知設定"
  ],
  "关闭通知偏好": [
    "Close notification preferences",
    "通知設定を閉じる"
  ],
  "正在加载…": [
    "Loading…",
    "読み込み中…"
  ],
  "正在读取完整消息…": [
    "Loading the full message…",
    "メッセージ全文を読み込み中…"
  ],
  "重新读取": [
    "Reload records",
    "再読み込み"
  ],
  "查看作者": [
    "View author",
    "作者を見る"
  ],
  "个月": [
    "months",
    "か月"
  ],
  "工房会员礼遇": [
    "Workshop membership benefits",
    "工房の会員特典"
  ],
  "档案会员礼遇": [
    "Archive membership benefits",
    "アーカイブの会員特典"
  ],
  "正在领取…": [
    "Claiming…",
    "受け取り中…"
  ],
  "工房创作补给": [
    "Workshop creative resources",
    "工房の創作リソース"
  ],
  "创作点数": [
    "Creative credits",
    "制作ポイント"
  ],
  "故事，已经遇见了新的人。": [
    "Your story has found someone new.",
    "あなたの物語が、新しい誰かに届きました。"
  ],
  "去市集看看": [
    "Visit the Market",
    "マーケットを見る"
  ],
  "你的第一件周边": [
    "Your first merch merch",
    "初めてのグッズ制作"
  ],
  "打开一张教学图片。": [
    "Open a tutorial image.",
    "チュートリアル画像を開きましょう。"
  ],
  "图片正在路上。": [
    "The image is on its way.",
    "画像を準備しています。"
  ],
  "先找到教学图片。": [
    "Find the tutorial image first.",
    "まずチュートリアル画像を見つけましょう。"
  ],
  "点亮起的图片，看看这个世界的角色。预览打开后，我们再继续。": [
    "Select the highlighted image to meet this world's character. We will continue when the preview opens.",
    "強調表示された画像を選び、この世界のキャラクターを見てみましょう。プレビューが開いたら次に進みます。"
  ],
  "已经进入图片列表，等教学素材加载完成就能继续。": [
    "The image list is open. Continue once the tutorial materials finish loading.",
    "画像一覧が開きました。チュートリアル素材の読み込みが終わると進めます。"
  ],
  "档案收着这个系列的角色、设定与作品。点「图片」，先认识其中的一位。": [
    "The Archive holds this series's characters, lore and works. Select “Images” to meet one of them.",
    "アーカイブには、このシリーズのキャラクター、設定、作品があります。「画像」を選んで見てみましょう。"
  ],
  "前往": [
    "Go to",
    "移動"
  ],
  "带上灵感，去见侍灵。": [
    "Bring your inspiration to the Attendant.",
    "ひらめきをアシスタントに伝えましょう。"
  ],
  "下一站是工房。你的系列和这张图，会和你一起过去。": [
    "Next is the Workshop. Your series and this image will come with you.",
    "次は工房です。シリーズとこの画像を引き継いで移動します。"
  ],
  "进入工房": [
    "Open the Workshop",
    "工房を開く"
  ],
  "认识侍灵，你的 AI 创作伙伴。": [
    "Meet the Attendant, your AI creative partner.",
    "AIの創作パートナー、アシスタントに会いましょう。"
  ],
  "参考图已经选好。打开侍灵后，说说想保留什么、改变哪里；想法和最后的选择都由你决定。": [
    "Your reference image is selected. Open the Attendant and explain what to keep or change. You decide the ideas and the final result.",
    "参考画像を選択しました。アシスタントを開き、残したい部分や変えたい部分を伝えましょう。アイデアと最終的な判断はあなたが決めます。"
  ],
  "把这一刻，留下来。": [
    "Save this moment.",
    "この瞬間を残しましょう。"
  ],
  "让想象，落在掌心。": [
    "Bring your imagination into your hands.",
    "想像を、手に取れる形に。"
  ],
  "挪动或缩放画面，让喜欢的部分落在安全区。满意后点「保存并返回周边」，保存成功才继续。": [
    "Move or resize the image to keep the part you like within the safe area. Select “Save and return to merch” and wait for it to save before continuing.",
    "画像を移動・拡大縮小し、見せたい部分をセーフエリア内に収めます。「保存してグッズに戻る」を選び、保存完了後に進んでください。"
  ],
  "故事可以走出屏幕，成为每天陪伴你的周边。我们先把这张作品放进一枚吧唧。": [
    "A story can leave the screen and become something you carry every day. Let's put this work on a badge.",
    "物語は画面を飛び出し、日々を共にするグッズになります。まずはこの作品を缶バッジにしてみましょう。"
  ],
  "让故事，走出系列。": [
    "Let the story leave its series.",
    "物語をシリーズの外へ届けましょう。"
  ],
  "名字与心意，都放好了吗？确认好发布信息后，点「发布到市集」，让大家遇见它。": [
    "Is the name and description ready? Review the publishing details, then select “Publish to the Market”.",
    "名前と説明は整いましたか？公開情報を確認し、「マーケットに公開」を選択してください。"
  ],
  "喜欢它吗？让它成为周边。": [
    "Like it? Turn it into merch.",
    "気に入ったら、グッズにしてみましょう。"
  ],
  "下一站，市集。": [
    "Next stop: the Market.",
    "次はマーケットです。"
  ],
  "挑一个喜欢的款式，把这版作品带上。": [
    "Choose a style you like and use this version of your work.",
    "好きなデザインを選び、このバージョンの作品を使いましょう。"
  ],
  "周边已经准备好，去给它写一封面向世界的介绍吧。": [
    "Your merch is ready. Write an introduction to share it with the world.",
    "グッズの準備ができました。世界に届ける紹介文を書きましょう。"
  ],
  "继续制作周边": [
    "Continue making merch",
    "グッズ制作を続ける"
  ],
  "前往发布": [
    "Go to publishing",
    "公開へ進む"
  ],
  "正在定位下一步…": [
    "Finding the next step…",
    "次の手順を探しています…"
  ],
  "退出教学": [
    "Exit tutorial",
    "チュートリアルを終了"
  ],
  "展开指引": [
    "Expand guide",
    "ガイドを展開"
  ],
  "侍灵同行": [
    "With your Attendant",
    "アシスタントと一緒に"
  ],
  "导览选项": [
    "Tour options",
    "ガイドの設定"
  ],
  "结束引导": [
    "End guide",
    "ガイドを終了"
  ],
  "结束引导，可从公告栏回来": [
    "End the guide; resume from the bulletin",
    "ガイドを終了（掲示板から再開できます）"
  ],
  "稍后继续": [
    "Continue later",
    "後で続ける"
  ],
  "找到这个位置": [
    "Find this location",
    "この場所を表示"
  ],
  "把这张图，带进新故事。": [
    "Bring this image into a new story.",
    "この画像から、新しい物語を始めましょう。"
  ],
  "点「带去创作」，这版图片会作为参考交给侍灵。原作会保留，我们从它开始创造新的版本。": [
    "Select “Use in a creation” to send this version to the Attendant as a reference. The original is preserved while you create a new version.",
    "「創作に使う」を選ぶと、このバージョンの画像が参考資料としてアシスタントに渡されます。原作を保持したまま新しいバージョンを作成します。"
  ],
  "正在打开…": [
    "Opening...",
    "オープニング..."
  ],
  "带去创作": [
    "Use in a creation",
    "創作に使う"
  ],
  "魔素": [
    "Mana",
    "マナ"
  ],
  "正在读取魔素…": [
    "Loading Mana…",
    "マナを読み込み中…"
  ],
  " 魔素": [
    " Mana",
    " マナ"
  ],
  " / 月": [
    " / month",
    " / 月"
  ],
  " / 年": [
    " / year",
    " / 年"
  ],
  "可用余额": [
    "Available balance",
    "利用可能残高"
  ],
  "支付暂未开放": [
    "Payments are not available yet",
    "決済はまだ利用できません"
  ],
  "补充魔素": [
    "Top up Mana",
    "マナを補充"
  ],
  "单次补充 · 不过期": [
    "One-time top-up · Never expires",
    "単発チャージ・有効期限なし"
  ],
  "每月补给": [
    "Monthly allowance",
    "毎月の付与"
  ],
  "每月刷新 · 不累计": [
    "Refreshes monthly · Does not roll over",
    "毎月更新・繰り越しなし"
  ],
  "计费周期": [
    "Billing cycle",
    "請求期間"
  ],
  "收支与订单": [
    "Transactions and orders",
    "利用履歴と注文"
  ],
  "订单记录": [
    "Order history",
    "注文履歴"
  ],
  "订单暂未同步。": [
    "Orders have not synced yet.",
    "注文がまだ同期されていません。"
  ],
  "暂无订单": [
    "No orders yet",
    "注文はまだありません"
  ],
  "最近收支": [
    "Recent transactions",
    "最近の利用履歴"
  ],
  "魔素变动": [
    "Mana changes",
    "マナの増減"
  ],
  "暂无收支": [
    "No transactions yet",
    "利用履歴はまだありません"
  ],
  "魔素已到账": [
    "Mana added",
    "マナが追加されました"
  ],
  "微信支付": [
    "WeChat Pay",
    "WeChat Pay"
  ],
  "使用微信扫描二维码，支付后自动到账。": [
    "Scan the QR code with WeChat. Mana will be added after payment.",
    "WeChatでQRコードを読み取ってください。支払い後、マナが自動で追加されます。"
  ],
  "起步提示": [
    "Getting started tip",
    "はじめに"
  ],
  "关闭起步提示": [
    "Close tip",
    "ヒントを閉じる"
  ],
  "主导航": [
    "Main navigation",
    "メインナビゲーション"
  ],
  "交汇地": [
    "Crossroads",
    "交差点"
  ],
  "欢迎回来": [
    "Welcome back",
    "おかえりなさい"
  ],
  "一个账号，连接创作与分享。": [
    "One account for creating and sharing.",
    "ひとつのアカウントで、創作と共有を。"
  ],
  "使用 RealRain Account 继续": [
    "Continue with RealRain Account",
    "RealRain Accountで続ける"
  ],
  "由 RealRain 统一登录": [
    "Sign in through RealRain",
    "RealRain共通ログイン"
  ],
  "先逛逛交汇地": [
    "Explore the Crossroads first",
    "まず交差点を見てみる"
  ],
  "让创作发生，让世界相遇。": [
    "Create something. Let worlds meet.",
    "創作が生まれ、世界が出会う。"
  ],
  "基于 ": [
    "Based on ",
    "作成元："
  ],
  "来源系列": [
    "Source series",
    "元のシリーズ"
  ],
  " 创建": [
    " created",
    " を作成"
  ],
  "来源详情": [
    "Source details",
    "出典の詳細"
  ],
  "系列来源": [
    "Series source",
    "シリーズの出典"
  ],
  "关闭来源详情": [
    "Close source details",
    "出典の詳細を閉じる"
  ],
  "基于此系列创建": [
    "Created from this series",
    "このシリーズから作成"
  ],
  "来源系列当前不可访问": [
    "The source series is currently unavailable",
    "元のシリーズには現在アクセスできません"
  ],
  "创建时间": [
    "Date created",
    "作成日時"
  ],
  "历史记录未包含时间": [
    "No timestamp in the historical record",
    "履歴に日時の記録がありません"
  ],
  "内容版本": [
    "Content version",
    "コンテンツのバージョン"
  ],
  "创建范围": [
    "Creation scope",
    "作成範囲"
  ],
  "创建时包含的内容": [
    "Content included at creation",
    "作成時に含まれたコンテンツ"
  ],
  "设定": [
    "Lore",
    "設定資料"
  ],
  "素材": [
    "Assets",
    "素材"
  ],
  "更早的来源": [
    "Earlier sources",
    "それ以前の出典"
  ],
  "查看申请与使用规则 →": [
    "View application and usage rules →",
    "申請と利用ルールを見る →"
  ],
  "切换系列": [
    "Switch series",
    "シリーズを切り替え"
  ],
  "切换后仍留在工房": [
    "Stay in the Workshop after switching",
    "切り替え後も工房を表示"
  ],
  "切换后继续浏览": [
    "Keep browsing after switching",
    "切り替え後も閲覧を続ける"
  ],
  "关闭系列选择": [
    "Close series selector",
    "シリーズの選択を閉じる"
  ],
  "搜索系列": [
    "Search Series",
    "シリーズを検索"
  ],
  "正在读取系列…": [
    "Loading Series…",
    "シリーズを読み込み中…"
  ],
  "没有匹配的系列": [
    "No matching Series",
    "一致するシリーズがありません"
  ],
  "还没有可切换的系列": [
    "No other series available",
    "切り替えられるシリーズがありません"
  ],
  "境": [
    "W",
    "界"
  ],
  "尚未就绪": [
    "Not ready yet",
    "準備ができていません"
  ],
  "当前": [
    "Current",
    "現在"
  ],
  "选择档案": [
    "Choose an archive",
    "アーカイブを選択"
  ],
  "切换档案": [
    "Switch archive",
    "アーカイブを切り替え"
  ],
  "关闭档案选择": [
    "Close archive selector",
    "アーカイブの選択を閉じる"
  ],
  "搜索档案": [
    "Search archives",
    "アーカイブを検索"
  ],
  "搜索系列或刻印": [
    "Search series or imprints",
    "シリーズや刻印を検索"
  ],
  "正在读取档案…": [
    "Loading archives…",
    "アーカイブを読み込み中…"
  ],
  "没有匹配的档案": [
    "No matching archives",
    "一致するアーカイブがありません"
  ],
  "还没有系列或刻印": [
    "No Series or imprints yet",
    "シリーズやインプリントはまだありません"
  ],
  "排队目标运行": [
    "Follow-up target",
    "キューの対象実行"
  ],
  "选择排队目标运行": [
    "Choose the run for this follow-up",
    "キューに追加する実行を選択"
  ],
  "请选择运行": [
    "Choose a run",
    "実行を選択してください"
  ],
  "运行": [
    "Run",
    "実行"
  ],
  "侍灵输入区": [
    "Agent input",
    "アシスタントの入力欄"
  ],
  "侍灵面板": [
    "Agent panel",
    "アシスタントパネル"
  ],
  "返回页面": [
    "Back to page",
    "ページに戻る"
  ],
  "对话簿面板": [
    "Conversation notebook panel",
    "会話ノートのパネル"
  ],
  "对话簿": [
    "Conversation notebook",
    "会話ノート"
  ],
  "关闭对话簿": [
    "Close conversation notebook",
    "会話ノートを閉じる"
  ],
  "搜索对话": [
    "Search conversations",
    "会話を検索"
  ],
  "对话状态": [
    "Conversation status",
    "会話の状態"
  ],
  "当前对话": [
    "Current conversation",
    "現在の会話"
  ],
  "已归档对话": [
    "Archived conversations",
    "アーカイブした会話"
  ],
  "保存名称": [
    "Save name",
    "名前を保存"
  ],
  "项待处理": [
    "pending",
    "件が処理待ち"
  ],
  "重命名": [
    "Rename",
    "名前を変更"
  ],
  "任务结束后可归档": [
    "Can be archived when the task ends",
    "タスク終了後にアーカイブできます"
  ],
  "归档": [
    "Archive",
    "アーカイブ"
  ],
  "任务结束后可删除": [
    "Can be deleted when the task ends",
    "タスク終了後に削除できます"
  ],
  "删除": [
    "Delete",
    "削除"
  ],
  "没有匹配的对话": [
    "No matching conversations",
    "一致する会話がありません"
  ],
  "还没有归档对话": [
    "No archived conversations",
    "アーカイブした会話はありません"
  ],
  "还没有对话": [
    "No conversations yet",
    "会話はまだありません"
  ],
  "收起侍灵": [
    "Minimize Agent",
    "アシスタントを折りたたむ"
  ],
  "收起": [
    "Collapse",
    "折りたたむ"
  ],
  "搜索或问侍灵（/）": [
    "Search or ask the Attendant (/)",
    "検索、またはアシスタントに質問（/）"
  ],
  "自动生成音视频": [
    "Generate audio and video automatically",
    "音声・動画を自動生成"
  ],
  "关闭时，生成音频或视频前先征求你的确认。开启后，素材就绪即可生成。": [
    "When off, you will be asked before generating audio or video. When on, generation can start as soon as materials are ready.",
    "オフの場合、音声や動画の生成前に確認します。オンの場合、素材が揃うと生成を開始できます。"
  ],
  "消息操作": [
    "Message actions",
    "メッセージの操作"
  ],
  "已复制": [
    "Copied",
    "コピーしました"
  ],
  "复制消息": [
    "Copy message",
    "メッセージをコピー"
  ],
  "复制": [
    "Copy",
    "コピー"
  ],
  "修改并从这里重新开始": [
    "Edit and restart from here",
    "編集してここからやり直す"
  ],
  "修改": [
    "Edit",
    "変更"
  ],
  "侍灵回复操作": [
    "Agent response actions",
    "アシスタントの返信の操作"
  ],
  "复制回复": [
    "Copy response",
    "返信をコピー"
  ],
  "从此轮创建分支": [
    "Branch from this turn",
    "このターンから分岐を作成"
  ],
  "侍灵模型": [
    "Attendant model",
    "アシスタントのモデル"
  ],
  "返回搜索": [
    "Back to search",
    "検索に戻る"
  ],
  "收起搜索与侍灵": [
    "Collapse search and Attendant",
    "検索とアシスタントを閉じる"
  ],
  "搜索 · 侍灵": [
    "Search · Attendant",
    "検索・アシスタント"
  ],
  "添加系列": [
    "Add a series",
    "シリーズを追加"
  ],
  "系列上下文": [
    "Series context",
    "シリーズのコンテキスト"
  ],
  "移除系列": [
    "Remove series",
    "シリーズを外す"
  ],
  "还没有系列，也可以直接对话": [
    "You can chat without a series",
    "シリーズがなくても会話できます"
  ],
  "搜索结果": [
    "Search results",
    "検索結果"
  ],
  "正在搜索…": [
    "Searching…",
    "検索中…"
  ],
  "搜索暂时不可用，按 Enter 重试。": [
    "Search is unavailable. Press Enter to retry.",
    "検索を利用できません。Enterキーで再試行してください。"
  ],
  "搜索类型": [
    "Search type",
    "検索の種類"
  ],
  "更多": [
    "More",
    "その他"
  ],
  "没有找到相关内容": [
    "No matching content",
    "関連するコンテンツがありません"
  ],
  "正在读取设置…": [
    "Loading settings…",
    "設定を読み込み中…"
  ],
  "快捷开始": [
    "Quick start",
    "クイックスタート"
  ],
  "将附带当前精确版本": [
    "Includes the exact current version",
    "現在の正確なバージョンを添付します"
  ],
  "根据当前页面准备": [
    "Prepared from the current page",
    "現在のページをもとに準備"
  ],
  "退出侍灵焦点模式": [
    "Exit Agent focus mode",
    "アシスタントの集中表示を終了"
  ],
  "搜索与侍灵": [
    "Search and assistant",
    "検索とアシスタント"
  ],
  " · 跟随当前版本": [
    " · Follows the current version",
    " ・最新バージョンを参照"
  ],
  " · 草稿": [
    " · Draft",
    " ・下書き"
  ],
  " · 已停用": [
    " · Disabled",
    " ・無効"
  ],
  " · 已删除": [
    " · Deleted",
    " ・削除済み"
  ],
  "附件": [
    "Attachments",
    "添付ファイル"
  ],
  "待发送文件": [
    "Files ready to send",
    "送信待ちのファイル"
  ],
  "发送时重试": [
    "Retry when sent",
    "送信時に再試行"
  ],
  "移除": [
    "Remove",
    "削除"
  ],
  "最近一次模型请求输入窗口，当前不可用": [
    "Input window for the latest model request is unavailable",
    "直近のモデルリクエストの入力ウィンドウは現在利用できません"
  ],
  "上下文": [
    "Context",
    "コンテキスト"
  ],
  "更新暂时中断": [
    "Updates paused",
    "更新が一時中断しています"
  ],
  "最近一次模型请求": [
    "Latest model request",
    "直近のモデルリクエスト"
  ],
  "输入窗口占用": [
    "Context window usage",
    "コンテキスト使用量"
  ],
  "暂无读数": [
    "No reading",
    "測定値なし"
  ],
  "更新暂时中断，当前保留上一次读数": [
    "Updates paused. Showing the last reading.",
    "更新が一時中断しています。前回の値を表示しています"
  ],
  "本次输入": [
    "Current input",
    "今回の入力"
  ],
  "Token，模型窗口": [
    "tokens, model window",
    "トークン、モデルのコンテキスト枠"
  ],
  "窗口余量": [
    "Window remaining",
    "ウィンドウの残量"
  ],
  "暂时没有读数": [
    "No reading available",
    "測定値はまだありません"
  ],
  "最近对话": [
    "Recent conversations",
    "最近の会話"
  ],
  "松开即可添加": [
    "Release to add",
    "ドロップして追加"
  ],
  "文件会先暂存，发送消息后才上传": [
    "Files stay staged until you send the message",
    "ファイルを一時保管し、送信後にアップロードします"
  ],
  "问侍灵": [
    "Ask the Attendant",
    "アシスタントに質問"
  ],
  "问侍灵（Ctrl / ⌘ + Enter）": [
    "Ask the Attendant (Ctrl / ⌘ + Enter)",
    "アシスタントに質問（Ctrl / ⌘ + Enter）"
  ],
  "↵ 问侍灵": [
    "↵ Ask the Attendant",
    "↵ アシスタントに質問"
  ],
  "正在加载模型": [
    "Loading models",
    "モデルを読み込み中"
  ],
  "模型…": [
    "Models…",
    "モデル…"
  ],
  "添加文件或资产": [
    "Add files or assets",
    "ファイルや素材を追加"
  ],
  "指令建议": [
    "Command suggestions",
    "コマンド候補"
  ],
  "没有匹配的指令": [
    "No matching commands",
    "一致するコマンドがありません"
  ],
  "永久删除": [
    "Permanently delete",
    "完全に削除"
  ],
  "将永久删除这段对话及其上下文。通过这段对话创建的项目资产仍会保留。此操作无法撤销。": [
    "This permanently deletes the conversation and its context. Project assets created from it remain available. This cannot be undone.",
    "会話とそのコンテキストを完全に削除します。この会話で作成した素材は保持されます。この操作は取り消せません。"
  ],
  "正在删除…": [
    "Deleting…",
    "削除中…"
  ],
  "永久删除对话": [
    "Permanently delete conversation",
    "会話を完全に削除"
  ],
  "早期档案对话": [
    "Earlier Archive conversations",
    "以前のアーカイブの会話"
  ],
  "关闭早期对话": [
    "Close earlier conversations",
    "以前の会話を閉じる"
  ],
  "这里保留了共通前的对话。新对话已在 档案和工房 共通。": [
    "Conversations from before unification are kept here. New conversations are shared across the Archive and Workshop.",
    "統合前の会話をここに保存しています。新しい会話はアーカイブと工房で共通です。"
  ],
  "返回列表": [
    "Back to list",
    "一覧に戻る"
  ],
  "你": [
    "You",
    "あなた"
  ],
  "侍灵": [
    "Attendant",
    "アシスタント"
  ],
  "未命名对话": [
    "Untitled conversation",
    "無題の会話"
  ],
  "暂无早期对话": [
    "No earlier conversations",
    "以前の会話はありません"
  ],
  "正在读取…": [
    "Loading…",
    "読み込み中…"
  ],
  "加载更多": [
    "Load more",
    "さらに読み込む"
  ],
  "消息": [
    "Messages",
    "メッセージ"
  ],
  "我的订单": [
    "My orders",
    "注文履歴"
  ],
  "收货地址": [
    "Shipping addresses",
    "配送先住所"
  ],
  "设置": [
    "Settings",
    "設定"
  ],
  "帮助与文档": [
    "Help and docs",
    "ヘルプとドキュメント"
  ],
  "粉丝": [
    "Followers",
    "フォロワー"
  ],
  "关注": [
    "Following",
    "フォロー中"
  ],
  "我创建的": [
    "Created by me",
    "自分が作成"
  ],
  "我加入的": [
    "Joined",
    "参加中"
  ],
  "还没有创建系列。": [
    "You haven't created any series yet.",
    "作成したシリーズはまだありません。"
  ],
  "还没有加入系列。": [
    "You haven't joined any series yet.",
    "参加しているシリーズはまだありません。"
  ],
  "查看全部系列": [
    "View all series",
    "すべてのシリーズを見る"
  ],
  "还没有系列。创建第一个系列，开始收好设定与素材。": [
    "Create your first series to keep your lore and materials together.",
    "最初のシリーズを作成し、設定や素材をまとめましょう。"
  ],
  "刻印台": [
    "Imprints",
    "刻印コレクション"
  ],
  "累计带回 ": [
    "Collected ",
    "取得済み："
  ],
  " 份刻印，来自 ": [
    " imprints from ",
    " 件の刻印、取得元："
  ],
  " 个系列": [
    " series",
    " のシリーズ"
  ],
  "份": [
    "imprints",
    "件"
  ],
  "刻印分页": [
    "Imprint pages",
    "刻印のページ"
  ],
  "上一页刻印": [
    "Previous imprints",
    "前の刻印"
  ],
  "下一页刻印": [
    "Next imprints",
    "次の刻印"
  ],
  "刻印记录暂未读取。": [
    "Imprints have not loaded yet.",
    "刻印の記録がまだ読み込まれていません。"
  ],
  "还没有带回刻印": [
    "No imprints collected yet",
    "取得した刻印はまだありません"
  ],
  "去发现": [
    "Discover",
    "見つける"
  ],
  "带回的刻印": [
    "Collected imprints",
    "取得した刻印"
  ],
  "历史刻印": [
    "Earlier imprint",
    "以前の刻印"
  ],
  "已领取的刻印": [
    "Collected imprint",
    "取得済みの刻印"
  ],
  " · 已点亮": [
    " · Activated",
    " ・点灯済み"
  ],
  "已点亮": [
    "Activated",
    "点灯済み"
  ],
  " 带回": [
    " · Collected",
    " に取得"
  ],
  "查看来源系列": [
    "View source series",
    "元のシリーズを見る"
  ],
  "来源信息当前不可见，领取记录仍保留。": [
    "The source is currently unavailable. Your collection record is preserved.",
    "出典は現在表示できません。取得記録は保持されています。"
  ],
  "选择这次创作的来源，作品会保留相应的署名和许可。": [
    "Choose a source for this creation. Its credits and license will stay with the work.",
    "今回の創作の出典を選択してください。作品にはクレジットとライセンスが引き継がれます。"
  ],
  "已刻印": [
    "Licensed imprints",
    "ライセンス取得済みの刻印"
  ],
  "选择素材并制作": [
    "Choose materials and create",
    "素材を選んで制作"
  ],
  "上传或选择自己的作品": [
    "Upload or choose your own work",
    "自分の作品をアップロード、または選択"
  ],
  "先创建一个系列，或在喜欢的 IP 会馆里领取刻印。": [
    "Create a series, or collect an imprint from an IP guild you like.",
    "シリーズを作成するか、好きなIPの会館で刻印を取得してください。"
  ],
  "继续漫游": [
    "Keep exploring",
    "探索を続ける"
  ],
  "等一件让你心动的作品": [
    "Find a work you love",
    "お気に入りの作品を見つけましょう"
  ],
  "在作品里挑选周边，它就会出现在这里。": [
    "Choose merch from a work to add it to your bag.",
    "作品からグッズを選ぶと、バッグに追加できます。"
  ],
  "正在读取购物袋…": [
    "Loading your bag…",
    "バッグを読み込み中…"
  ],
  "待摆放的周边": [
    "Merch to arrange",
    "配置するグッズ"
  ],
  "待摆放": [
    "Not placed yet",
    "未配置"
  ],
  "当前摆放尚未保存到本机": [
    "This arrangement has not been saved to this device.",
    "この配置はまだ端末に保存されていません。"
  ],
  "购物袋清单": [
    "Bag items",
    "バッグの中身"
  ],
  "加入": [
    "Join",
    "参加"
  ],
  "已加入": [
    "Joined",
    "参加中"
  ],
  "加入系列": [
    "Join series",
    "シリーズに参加"
  ],
  "点击退出系列": [
    "Leave series",
    "シリーズから退出"
  ],
  "加入系列：{name}": [
    "Join {name}",
    "{name}に参加"
  ],
  "退出系列：{name}": [
    "Leave {name}",
    "{name}から退出"
  ],
  "创建者": [
    "Creator",
    "作成者"
  ],
  "角色": [
    "Character",
    "キャラクター"
  ],
  "文字": [
    "Text",
    "テキスト"
  ],
  "组织": [
    "Organization",
    "組織"
  ],
  "徽章": [
    "Badge",
    "缶バッジ"
  ],
  "吧唧": [
    "Badge",
    "缶バッジ"
  ],
  "交汇之地管理处": [
    "Crossroads Administration",
    "交差点管理局"
  ],
  "来自交汇之地管理处 · 置顶": [
    "From Crossroads Administration · Pinned",
    "交差点管理局より・ピン留め"
  ],
  "欢迎来到交汇之地，远道而来的客人：": [
    "Welcome to the Crossroads, traveler.",
    "遠くからお越しの皆さま、交差点へようこそ。"
  ],
  "这里连接着诸多系列。你可以探访陌生的世界，收藏心仪的周边，也可以与侍灵一道，创造和经营自己的系列。": [
    "Many series meet here. Explore unfamiliar worlds, collect merch you love, or work with the Attendant to create and build your own series.",
    "ここでは、さまざまなシリーズがつながっています。未知の世界を訪ね、お気に入りのグッズを集めたり、アシスタントと一緒に自分のシリーズを作り育てたりできます。"
  ],
  "愿你在此寻得所爱，让眼中的系列，成为身边的风景吧。": [
    "May you find what you love here and bring a little of your series into everyday life.",
    "ここで好きなものに出会い、心に描くシリーズが日々の風景になりますように。"
  ],
  "——交汇之地管理处": [
    "— Crossroads Administration",
    "— 交差点管理局"
  ],
  "互动": [
    "Interactions",
    "交流"
  ],
  "回复": [
    "Reply",
    "返信"
  ],
  "礼物": [
    "Gift",
    "ギフト"
  ],
  "信箱，{count} 条未读": [
    "Inbox, {count} unread",
    "受信箱、未読{count}件"
  ],
  "{source} · 通知与站内信": [
    "{source} · Notifications and messages",
    "{source}・通知とメッセージ"
  ],
  "来自 {source} · {date}": [
    "From {source} · {date}",
    "{source}より・{date}"
  ],
  "{source} 消息": [
    "{source} messages",
    "{source}のメッセージ"
  ],
  "{source} 消息提醒": [
    "{source} message notifications",
    "{source}のメッセージ通知"
  ],
  "共 {count} 个系列": [
    "{count} series",
    "シリーズ {count}件"
  ],
  "{name}：上一页杂志": [
    "{name}: previous page",
    "{name}：前のページ"
  ],
  "{name}：下一页杂志": [
    "{name}: next page",
    "{name}：次のページ"
  ],
  "{name}杂志翻页": [
    "{name} page navigation",
    "{name}のページ切り替え"
  ],
  "部分系列暂未加载，请重试。": [
    "Some series could not be loaded. Try again.",
    "一部のシリーズを読み込めませんでした。再試行してください。"
  ],
  "消息暂未同步，请重试": [
    "Messages could not sync. Try again.",
    "メッセージを同期できませんでした。再試行してください。"
  ],
  "购物袋暂时未同步，请重试。": [
    "Your bag could not sync. Try again.",
    "バッグを同期できませんでした。再試行してください。"
  ],
  "连接恢复后可以继续当前页面。": [
    "You can continue on this page once the connection is restored.",
    "接続が復旧すると、このページで続けられます。"
  ],
  "关于系列、作品与创作的来访须知。": [
    "A guide to series, works and creating.",
    "シリーズ、作品、創作についてのご案内。"
  ],
  "发现带你浏览作品，关注里查看新的动态；营地收好系列与收藏。手机上的购物袋、订单和地址都在「我的」。": [
    "Browse works in Discover and updates in Following. Camp keeps your series and saved items together. On mobile, your bag, orders and addresses are under Me.",
    "「見つける」で作品、「フォロー中」で最新情報を閲覧できます。キャンプにはシリーズや保存したものがまとまっています。スマートフォンでは、バッグ・注文・住所は「マイページ」にあります。"
  ],
  "看看如何下单": [
    "Learn how to order",
    "注文の流れを知る"
  ],
  "打开一件周边，选择规格、加入购物袋，再核对商品和金额。教学无需填写收货信息，也不会创建订单。": [
    "Open a product, choose its options, add it to your bag, then review the items and total. The tutorial requires no shipping information and creates no order.",
    "商品を開いて仕様を選び、バッグに追加して商品と金額を確認します。チュートリアルでは配送先の入力は不要で、注文も作成されません。"
  ],
  "按自己的节奏继续": [
    "Continue at your own pace",
    "自分のペースで続ける"
  ],
  "引导可以随时关闭，也可以从公告重新打开。创建第一个系列后，再认识广场里的发布入口。": [
    "Close the guide whenever you like and reopen it from announcements. After creating your first series, explore the publishing entry in its square.",
    "ガイドはいつでも閉じられ、お知らせから再開できます。最初のシリーズを作成したら、広場の公開機能を見てみましょう。"
  ],
  "还没有系列。创建第一个系列，开始收存设定与素材。": [
    "Create your first series to keep your lore and materials together.",
    "最初のシリーズを作成し、設定や素材をまとめましょう。"
  ],
  "我的": [
    "Me",
    "マイページ"
  ],
  "附上创作": [
    "Attach a creation",
    "創作を添付"
  ],
  "移除附上的创作": [
    "Remove attached creation",
    "添付した創作を外す"
  ],
  "保存回复": [
    "Save reply",
    "返信を保存"
  ],
  "留下留言": [
    "Post message",
    "メッセージを投稿"
  ],
  "查看更多留言": [
    "More messages",
    "ほかのメッセージを見る"
  ],
  "编辑回复": [
    "Edit reply",
    "返信を編集"
  ],
  "取消置顶": [
    "Unpin",
    "ピン留めを解除"
  ],
  "系列已创建，引导进度暂未保存。可以重试，或直接进入系列。": [
    "Your series was created, but guide progress could not be saved. Try again or open the series.",
    "シリーズは作成されましたが、ガイドの進行状況を保存できませんでした。再試行するか、シリーズを開いてください。"
  ],
  "还没有系列。创建第一个，开始收存设定与素材。": [
    "Create your first series to keep your lore and materials together.",
    "最初のシリーズを作成し、設定や素材をまとめましょう。"
  ],
  "交汇之地公告": [
    "Crossroads announcement",
    "交差点からのお知らせ"
  ],
  "打开入门引导": [
    "Open the introduction",
    "入門ガイドを開く"
  ]
};
